import * as React from 'react';
import {Route, Redirect} from 'react-router-dom';
import HomePage from './pages/HomePage';
import CollegePage from './pages/CollegePage';
import DepartmentPage from './pages/DepartmentPage';
import { FacultyPage } from './pages/FacultyPage';
import {styles} from "./styles/App";
import { css } from 'aphrodite';
import {LoginPage} from "./pages/LoginPage";
import {Application} from "./core/application"
import { FacultyListPage } from './pages/FacultyListPage';
import {TableauSponsorPage} from './pages/TableauSponsorPage';
import {TableauFacultyPage} from './pages/TableauFacultyPage';
import {TableauCostSharePage} from './pages/TableauCostSharePage';
import {TableauCollegesResearchInstitutesPage} from './pages/TableauCollegesResearchInstitutesPage';
import {TableauAwardSearchPage} from './pages/TableauAwardSearchPage'
import {TableauProposalSearchPage} from './pages/TableauProposalSearchPage'
import {TableauProposalAwardSearchPage} from './pages/TableauProposalAwardSearchPage'
import { AggregateCollege } from './pages/AggregateCollege';
import queryString from 'query-string';
import { library } from '@fortawesome/fontawesome-svg-core'
import {fas} from "@fortawesome/free-solid-svg-icons";
import {  far,faCheckSquare, faSquare, faMinusSquare } from "@fortawesome/free-regular-svg-icons";
import { AggrementPage } from './pages/AgreementPage';
import { inject } from 'mobx-react';
import { appStore } from './mobx/AppStore';
import { SearchPage } from './pages/SearchPage';
import { SearchListPage } from './pages/SearchListPage';

@inject('store')
class App extends React.Component {
  //static App : instance ;
  //window: window;

   //constructor () {
  //	super(props);
  //  window()
  //	}
  public render() {
    return (
      <React.Fragment>
        <div id="app-content" className={css(styles.App)} >
          <Route path="/" exact={true} render={this.buildHomePage} />
          <Route path="/agreement" exact={true} render={this.buildAgreementPage} />
          {
          //<Route path="/aggregate-college" exact={true} render={this.buildAggregateCollegePage} />
          }
          <Route path="/login" exact={true} render={this.buildLoginPage} />
          {
          //<Route path="/college/:id" exact={true} render={this.buildCollegePage} />
          //<Route path="/department/:id" exact={true} render={this.buildDepartmentPage} />
          //<Route path="/faculty/:id" exact={true} render={this.buildFacultyPage} />

          //<Route path="/facultylist" exact={true} render={this.buildFacultyListPage} />
          }
          <Route path="/search" exact={true} render={this.buildSearchPage} />
          <Route path="/searchlist" exact={true} render={this.buildSearchListPage} />
          <Route path="/faculty" exact={true} render={this.buildTableauFaculty} />

          <Route path="/cost-share" exact={true} render={this.buildTableauCostShare} />
          <Route path="/colleges-research-institutes" exact={true} render={this.buildTableauCollegesResearchInstitutes} />
          <Route path="/sponsors" exact={true} render={this.buildTableauSponsor} />
          <Route path="/award-search" exact={true} render={this.buildTableauAwardSearch} />
          <Route path="/proposal-search" exact={true} render={this.buildTableauProposalSearch} />
          <Route path="/proposal-award-search" exact={true} render={this.buildTableauProposalAwardSearch} />

        </div>
      </React.Fragment>
    );
  }
  
  private buildHomePage(prop: any){
      if(Application.getIsAgreed()){
        return <HomePage history = {prop.history}/>
      }else{
        return <Redirect to = "/agreement" />
      }
  }
  
  private buildAgreementPage(prop: any){
    return <AggrementPage history = {prop.history}/>
  }

  private buildAggregateCollegePage(prop: any){
      return <AggregateCollege history = {prop.history} />
  }

  private buildLoginPage(prop: any) {
    return <LoginPage history = {prop.history}/>
  }

  private buildCollegePage(prop: any) {
    //var _id = prop.match.params.id;
    return <CollegePage history = {prop.history}/>
  }

  private buildDepartmentPage(prop: any) {
    //var _id = prop.match.params.id;
    return <DepartmentPage history = {prop.history}/>
  }
  private buildTableauSponsor(prop: any) {
      //var _id = prop.match.params.id;
      return <TableauSponsorPage history = {prop.history}/>
    }
  private buildTableauCollegesResearchInstitutes(prop: any) {
      //var _id = prop.match.params.id;
      return <TableauCollegesResearchInstitutesPage history = {prop.history}/>
    }
  private buildTableauCostShare(prop: any) {
    //var _id = prop.match.params.id;
    return <TableauCostSharePage history = {prop.history}/>
        }
  private buildTableauFaculty(prop: any) {
     //var _id = prop.match.params.id;
     return <TableauFacultyPage history = {prop.history}/>
                }
  private buildTableauAwardSearch(prop: any) {
     //var _id = prop.match.params.id;
     return <TableauAwardSearchPage history = {prop.history}/>
                }
 private buildTableauProposalSearch(prop: any) {
     //var _id = prop.match.params.id;
     return <TableauAwardSearchPage history = {prop.history}/>
                }
  private buildTableauProposalAwardSearch(prop: any) {
      //var _id = prop.match.params.id;
      return <TableauAwardSearchPage history = {prop.history}/>
                 }

  private buildFacultyPage(prop: any) {
    const _id = prop.match.params.id;
    const params = queryString.parse(prop.location.search)
    let section;
    if(params.section !== undefined && params.section !== null){
      section = +params.section;
    }else{
      section = 0;
    }
    return <FacultyPage author_id={_id} history = {prop.history} section={section} />
  }

  private buildFacultyListPage(prop: any) {
    return <FacultyListPage index={"A"} history = {prop.history}/>
  }

  private buildSearchPage(prop: any) {
    return <SearchPage history = {prop.history}  />
  }

  private buildSearchListPage(prop: any) {
    const params = queryString.parse(prop.location.search)
    let options = "";
    if(params.options !== undefined && params.options !== null){
      if(Array.isArray(params.options)){
        options = params.options[0]
      }else{
        options = params.options;
      }
    }else{
      options = "";
    }

    return <SearchListPage history = {prop.history} searchOptions={options} />

  }

}

library.add(far,fas,faCheckSquare,faMinusSquare)

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx